<template>
  <div :class="standalone ? 'h-[70px]' : 'h-[70px] xs-max:h-[54px] sm:-mr-10 xs-max:-mr-32 sm:pr-4'">
    <div class="healthy-logos__clinicians-wrap h-[70px]">
      <iframe
        data-state="max"
        class="iframe-frontrow-sticker xs-max:!scale-[0.7]"
        :id="iframeId"
        frameborder="0"
        loading="lazy"
        title="Clinicians sticker"
        :src="frontrowIframeSrc"></iframe>
    </div>
  </div>
</template>

<script setup>
import { toRef } from 'vue'
import { useFrontrowSticker } from '~/composables/useFrontrowSticker'

const props = defineProps({
  defaultFrontrowId: {
    type: String,
    default: '3091'
  },
  frontrowProductMap: {
    type: String,
    default: '{}'
  },
  iframeId: {
    type: String,
    default: 'frontrow-sticker'
  },
  standalone: {
    type: Boolean,
    default: false
  }
})

const { frontrowIframeSrc } = useFrontrowSticker({
  defaultFrontrowId: toRef(props, 'defaultFrontrowId'),
  frontrowProductMap: toRef(props, 'frontrowProductMap'),
  iframeId: toRef(props, 'iframeId')
})
</script>

<style scoped>
.iframe-frontrow-sticker {
  width: 100%;
  height: 100%;
}
</style>
